import {
    SHOW_UNAVAILABLE_ITEM_MODAL,
    SHOW_SB_TRADE_ONBOARDING,
    UNAVAILABLE_ITEM_NOTIFICATION_KEY,
    SB_TRADE_ONBOARDING_NOTIFICATION_KEY,
} from '../finding/SbRespNotifications/sbRespNotificationConstants';

export function sbRespNotificationsReducer(state, action) {
    switch (action.type) {
        case SHOW_UNAVAILABLE_ITEM_MODAL:
            return {
                ...state,
                notifications: { [UNAVAILABLE_ITEM_NOTIFICATION_KEY]: true },
            };
        case SHOW_SB_TRADE_ONBOARDING:
            return {
                ...state,
                notifications: { [SB_TRADE_ONBOARDING_NOTIFICATION_KEY]: true },
            };
        default:
            return state || { notifications: {} };
    }
}
